import { PayloadAction } from '@reduxjs/toolkit';

import { EditorState } from 'editor/src/store/editor/types';

const setFocusedMediaElementUuidReducer = (state: EditorState, action: PayloadAction<number | undefined>) => {
  state.focusedMediaElementUuid = action.payload;
};

export default setFocusedMediaElementUuidReducer;
